const path = "/remocao/inscricao-distribuicao";
export default {
  dadosInscricao: `${path}/listar-inscricao`,
  inserirChecked: `${path}/inserir-checked`,
  upload: (ano, cpf) => `/remocao/upload-remocao/upload-documentos-docs/${ano}/${cpf}`,
  listarUloads: (ano, cpf) => `${path}/listar-arquivos/${ano}/${cpf} `,
  removerUpload: (ano, cpf, nomeArquivo) => `${path}/remover-arquivo/${ano}/${cpf}/${nomeArquivo}`,
};
